import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let lang = 'nl'
if(localStorage.getItem('lang')){
  lang = localStorage.getItem('lang')
}

const store = new Vuex.Store({
  state: {
    $lang: lang
  },
  mutations: {
    update$lang: function(state, newLang) { 
      state.$lang = newLang; 
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js